module.exports = __webpack_public_path__ + "static/img/1.4342d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/complete/1.png
// module id = pj2A
// module chunks = 1